export default {"en-US": __webpack_public_path__ + "i18n/en-US.5b6ef76b.i18next.json","ja-JP": __webpack_public_path__ + "i18n/ja-JP.dbc37d55.i18next.json"};